import { formatTimeAgo } from './formatTimeAgo';

const WEEK_MS = 7 * 86_400_000;

const pad2 = (n: number) => n.toString().padStart(2, '0');

const toAbsolute = (date: Date): string => {
  const day = pad2(date.getDate());
  const month = pad2(date.getMonth() + 1);
  const hour24 = date.getHours();
  const hour12 = ((hour24 + 11) % 12) + 1;
  const minute = pad2(date.getMinutes());
  const period = hour24 < 12 ? 'AM' : 'PM';
  return `${day}/${month}, ${hour12}:${minute}${period}`;
};

// Relative ("2 mins ago", "1 day ago") within the last week, otherwise an
// absolute "DD/MM, H:MMAM/PM" timestamp (matches the History design).
export const formatHistoryTimestamp = (
  iso: string,
  now: number = Date.now()
): string => {
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return '';
  if (now - then < WEEK_MS) return formatTimeAgo(iso, now);
  return toAbsolute(new Date(then));
};
